import React, { useEffect, useState } from "react";
// Import Swiper styles
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
// import icons
import {
  AiOutlinePlus,
  AiFillHeart,
  AiFillStar,
  AiOutlineMinus,
} from "react-icons/ai";

// import images
import person1 from "../../images/TestemonileBlocks/Image1.png";
import person2 from "../../images/TestemonileBlocks/Image2.png";
import person3 from "../../images/TestemonileBlocks/Image3.png";
// import tshirt from "../../images/tshirt.png";
// import component
import "./ProductDetails.scss";
import TestemonileBlock from "../../components/TestemonileBlocks/TestemonileBlock";
import { QuestionBlock } from "../../components/questionBlock/questionBlock";
import Specialoffer from "../../containers/specialoffers/Specialoffer";
import { useParams } from "react-router";
import { useDispatch } from "react-redux";
import { addToCart } from "../../containers/rtk/slices/slice";
import ProductCard from "../../components/product_card/ProductCard";

// start choose color func
const ChooseColor = () => {
  let AllColors = document.querySelectorAll(".colors ul li");
  let spancolor = document.querySelector(".colors h3 span");
  AllColors.forEach((ColorLi) => {
    ColorLi.addEventListener("click", (e) => {
      console.log(e.target.dataset.color);
      spancolor.innerText = e.target.dataset.color;
    });
  });
};
// select size Func
const SelectSize = () => {
  let AllSizes = document.querySelectorAll(".sizes ul li");
  let sizespan = document.querySelector(".sizes h4 span");
  AllSizes.forEach((size) => {
    size.addEventListener("click", (e) => {
      AllSizes.forEach((sizeli) => {
        sizeli.classList.remove("activesize");
      });
      size.classList.add("activesize");
      sizespan.innerText = e.target.innerText;
    });
  });
};
const ProductDetails = () => {
  // start increase func
  const [qty, setqty] = useState(1);
  const increaseqty = () => {
    setqty((prevqty) => {
      let newqty = prevqty + 1;
      return newqty;
    });
  };

  const decreaseeqty = () => {
    setqty((prevqty) => {
      let newqty = prevqty - 1;
      if (newqty < 1) {
        newqty = 1;
      }
      return newqty;
    });
  };
  // get product id and fetch it
  const [product, setproduct] = useState([]);
  const params = useParams();
  let api = "https://rus-digital-televisions.onrender.com/allproduct";
  fetch(`${api}/${params.productId}`)
    .then((res) => res.json())
    .then((data) => setproduct(data));
  useEffect(() => {
    ChooseColor();
    SelectSize();
    loadsimilar();
  }, []);
  // handle similar products
  const [similarproduct, setprod] = useState([]);
  const loadsimilar = () => {
    fetch("https://rus-digital-televisions.onrender.com/allproduct")
      .then((res) => res.json())
      .then((data) => setprod(data.slice(30, 50)));
  };
  const dispatch = useDispatch();
  return (
    <>
      <div className="product_details">
        <div className="container">
          <div className="ProductContainer">
            <div className="row">
              <div className="productimg col-lg-7 col-md-12 col-sm-12">
                <div className="product_icon">
                  <span>
                    <AiOutlinePlus />
                    &nbsp;New in
                  </span>
                  <small>
                    <AiFillHeart />
                  </small>
                </div>
                <img src={product.img} alt="productimg"></img>
              </div>
              <div className="productdetail col-lg-5 col-md-12 col-sm-12">
                <h5>{product.name}</h5>
                <div className="price">
                  <span>${product.price}</span>
                  <p>
                    <AiFillStar />
                    4.9 .<a href="ref">142 reviews</a>.
                    <small>
                      <AiOutlinePlus />
                      New in
                    </small>
                  </p>
                </div>
                <div className="colors">
                  <h3>
                    color: <span>Blue</span>
                  </h3>
                  <ul>
                    <li
                      style={{ backgroundColor: "black" }}
                      data-color="black"
                    ></li>
                    <li
                      style={{ backgroundColor: "#bd6a39" }}
                      data-color="brown"
                    ></li>
                    <li
                      style={{ backgroundColor: "#e72765" }}
                      data-color="Pink"
                    ></li>
                    <li
                      style={{ backgroundColor: "#1d4178" }}
                      data-color="blue"
                    ></li>
                    <li
                      style={{ backgroundColor: "#f31717" }}
                      data-color="red"
                    ></li>
                  </ul>
                </div>
                <div className="sizes">
                  <h4>
                    Size:<span>XS</span>{" "}
                  </h4>
                  <ul>
                    <li className="activesize">XS</li>
                    <li>S</li>
                    <li>M</li>
                    <li>L</li>
                    <li>XL</li>
                    <li>XXL</li>
                  </ul>
                </div>
                <div className="count">
                  <button className="decrese" onClick={() => decreaseeqty()}>
                    <AiOutlineMinus />
                  </button>
                  <span>{qty} </span>
                  <button className="increase" onClick={() => increaseqty()}>
                    <AiOutlinePlus />
                  </button>
                  <button
                    className="Addtocart"
                    onClick={() => dispatch(addToCart(product))}
                  >
                    Add To Cart
                  </button>
                </div>
                <div className="Faq">
                  <QuestionBlock
                    question={"Description "}
                    answer={
                      "Fashion is a form of self-expression and autonomy at a particular period and place and in a specific context, of clothing, footwear, lifestyle, accessories, makeup, hairstyle, and body posture."
                    }
                  />
                  <QuestionBlock
                    question={"How to use "}
                    answer={
                      "Use this as a guide. Preference is a huge factor — if you're near the top of a size range and/or prefer more coverage, you may want to size up."
                    }
                  />
                  <QuestionBlock
                    question={"FAQ "}
                    answer={
                      "All full-priced, unworn items, with tags attached and in their original packaging are eligible for return or exchange within 30 days of placing your order.Please note, packs must be returned in full. We do not accept partial returns of packs."
                    }
                  />
                </div>
              </div>

              <div className="productDescription">
                <h4>Product Details</h4>
                <div className="description">
                  <p>
                    The patented eighteen-inch hardwood Arrowhead deck ---
                    finely mortised in, makes this the strongest and most rigid
                    canoe ever built. You cannot buy a canoe that will afford
                    greater satisfaction.
                  </p>

                  <p>
                    The St. Louis Meramec Canoe Company was founded by Alfred
                    Wickett in 1922. Wickett had previously worked for the Old
                    Town Canoe Co from 1900 to 1914. Manufacturing of the
                    classic wooden canoes in Valley Park, Missouri ceased in
                    1978.
                  </p>
                  <ul>
                    <li>
                      <small></small>Regular fit, mid-weight t-shirt
                    </li>
                    <li>
                      <small></small>
                      Natural color, 100% premium combed organic cotton
                    </li>
                    <li>
                      <small></small>
                      Quality cotton grown without the use of herbicides or
                      pesticides - GOTS certified
                    </li>
                    <li>
                      <small></small>Soft touch water based printed in the USA
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="TestemonileSec">
              <h3>
                <AiFillStar />
                &nbsp;4,87 · 142 Reviews
              </h3>
              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <TestemonileBlock
                    img={person1}
                    title={"Cody Fisher"}
                    date={"May 20, 2021 "}
                    description={
                      "Very nice feeling sweater. I like it better than a regular hoody because it is tailored to be a slimmer fit. Perfect for going out when you want to stay comfy. The head opening is a little tight which makes it a little."
                    }
                  />
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <TestemonileBlock
                    img={person2}
                    title={"Stiven Hokinhs"}
                    date={"December 22, 2021 "}
                    description={
                      "I love the charcoal heavyweight hoodie. Still looks new after plenty of washes. If you’re unsure which hoodie to pick."
                    }
                  />
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <TestemonileBlock
                    img={person3}
                    title={"Dahon Stiven"}
                    date={"December 12, 2022 "}
                    description={
                      "Before buying this, I didn't really know how I would tell a high qualitysweatshirt, but after opening, I was very impressed. The material is super soft and comfortable and the sweatshirt also has a good weight to it."
                    }
                  />
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <TestemonileBlock
                    img={person1}
                    title={"Gropishta keo"}
                    date={"August 15, 2022 "}
                    description={
                      "The quality and sizing mentioned were accurate and really happy with the purchase. Such a cozy and comfortable hoodie. Now that it’s colder, my husband wears his all the time. I wear hoodies all the time."
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          {/* start similar produsts */}
          <div className="similarProducts">
            <h4>Customers also purchased</h4>
            <div className="row">
              <Swiper
                loop={true}
                breakpoints={{
                  320: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  // when window width is >= 480px
                  480: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  // when window width is >= 640px
                  600: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },

                  640: {
                    slidesPerView: 3,
                    spaceBetween: 120,
                  },
                  992: {
                    slidesPerView: 4,
                    spaceBetween: 17,
                  },
                }}
                navigation={{
                  clickable: true,
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                pagination={{
                  clickable: true,
                }}
                // modules={[Pagination]}
                modules={[Navigation]}
                className="mySwiper productswiper"
              >
                {similarproduct.map((ele) => {
                  return (
                    <SwiperSlide key={ele.id}>
                      <ProductCard
                        productimg={ele.img}
                        name={ele.name.slice(0, 20)}
                        discount={ele.discount}
                        price={ele.price}
                        productdetails={ele}
                      />
                    </SwiperSlide>
                  );
                })}

                <button className="show_more">Show More</button>
              </Swiper>
            </div>
          </div>

          {/* start special offer comp */}
          <Specialoffer />
          {/* start footer comp  */}
        </div>
      </div>
    </>
  );
};

export default ProductDetails;
